// extracted by mini-css-extract-plugin
module.exports = {"Container":"Rating_Container__WmiBz","Rating":"Rating_Rating__CWaJI"};